import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { NumberSchema } from "../../Schemas/Broadcast";

export interface FilterList extends IFilterSchema {
  column: NumberListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: NumberListColumnSortable;
}

export enum NumberStatusEnum {
  CREATED = "created",
  RETRY = "retry",
  WAITING_FOR_SEND = "waiting_for_send",
  SENDING = "sending",
  FAILED = "failed",
  ANSWERED = "answered",
  BLOCKED = "blocked",
  NO_ANSWER = "no_answer",
  BUSY = "busy",
  REJECTED = "rejected",
  UNREACHABLE = "unreachable",
  DEVICE_OFF = "device_off",
  INVALID_NUMBER = "invalid_number",
  CANCELED = "canceled",
  PENDING = "pending",
}

export enum NumberListColumnFilterable {
  VOICE_BROADCAST_ID = "voice_broadcast_id",
  NUMBER = "number",
  EXTENSION = "extension",
  CALL_INPUT = "call_input",
  TOTAL_WAITING_TIME = "total_waiting_time",
  TOTAL_TALK_TIME = "total_talk_time",
  TOTAL_CAST = "total_cast",
  TRIES = "tries",
  PBX_TRUNK_ID = "pbx_trunk_id",
  PBX_SERVER_ID = "pbx_server_id",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
  ID = "id",
}
export enum NumberListColumnSortable {
  VOICE_BROADCAST_ID = "voice_broadcast_id",
  NUMBER = "number",
  EXTENSION = "extension",
  CALL_INPUT = "call_input",
  TOTAL_WAITING_TIME = "total_waiting_time",
  TOTAL_TALK_TIME = "total_talk_time",
  TOTAL_CAST = "total_cast",
  TRIES = "tries",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
  ID = "id",
}

interface NumberListQueryString extends IListQueryStringSchema {
  filters?: FilterList[];
  sorts?: Sort[];
}

interface NumberListResponseBody extends IResponseBody {
  data: {
    voice_broadcast_numbers: NumberSchema[];
    total: number;
  };
}

export class NumberListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/voice-broadcast-numbers`;
  }

  async list(
    queryStrings?: NumberListQueryString
  ): Promise<NumberListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
